module.exports = __webpack_public_path__ + "static/img/produce13.5b888a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce13.png
// module id = 143
// module chunks = 4